import React from 'react';
import { HStack, Text, Box } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Compact breadcrumb trail for sub-pages.
 * @param {{ items: { label: string, to?: string }[] }} props
 *   The last item is rendered as the current page (never a link).
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;
  return (
    <HStack spacing={2} fontSize="sm" mb={3} aria-label="Breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={`${item.label}-${i}`}>
            {i > 0 && (
              <Text as="span" color="gray.300" aria-hidden>
                /
              </Text>
            )}
            {isLast || !item.to ? (
              <Text as="span" color="gray.700" fontWeight="semibold" aria-current={isLast ? 'page' : undefined}>
                {item.label}
              </Text>
            ) : (
              <Box as={RouterLink} to={item.to} color="brand.600" _hover={{ color: 'brand.500' }}>
                {item.label}
              </Box>
            )}
          </React.Fragment>
        );
      })}
    </HStack>
  );
}
